module.exports = __webpack_public_path__ + "static/media/DarkBgImage.930a1ab0.png";